import type { FilterLocation } from "@modules/types"
import { isMobile } from "@modules/util/device"
import { getCategories, getCategoriesAsString } from "../category"
import { getFiltersAsString } from "../filter"
import { setCityAddresses } from "./city-addresses-select"
import { getSearchText } from "./search-text-data"
import { setShowResultsButton } from "./show-results-button"

export const getLocationInputElement = () => document.querySelector<HTMLInputElement>("#regiosuche")

document.querySelector(".ortsuche-hinweis-link")?.addEventListener("click", () => {
    if (isMobile()) {
        $("#fltCont").modal("hide")
        $("#fltRegio").modal("show")
        getLocationInputElement()?.focus()
        getLocationInputElement()?.select()
    } else {
        getLocationInputElement()?.focus()
        getLocationInputElement()?.select()
    }
})

/* request parameters old yii request. if anything is missing or fails another parameter of those needed?:
    viewType: list
    orderType: Reihenfolge
    saveInputData: true
    page: 1
    getOrderedAdverts: 1
    locationName: Alle Regionen
    seoPageUrl: /sex-anzeigen
    module: ldsmobile
    appendPages: true
    locationType: ort
    locationSlug: hanau
    landId: 105
    filterPath: /huren-hostessen,escort/figur:skinny,schlank,normal;typ:deutsch,latina
    breadcrumb[Ladies.de]: https://master.dev1m.ladies.de
    breadcrumb[Alle Regionen]: https://master.dev1m.ladies.de/sex-anzeigen
*/
export function fetchApiWithNewLocation(selectedLocation: FilterLocation) {
    const url = new URL(`${window.location.origin}/api/anzeigen/count`)
    url.searchParams.set("locationSlug", selectedLocation.slug)
    url.searchParams.set("locationName", selectedLocation.name)
    url.searchParams.set("locationType", selectedLocation.locationType)
    url.searchParams.set("umkreisBis", "20")
    url.searchParams.set("umkreisVon", "0")
    const filterPath = encodeURI(
        (getCategories().length > 0 ? `${getCategoriesAsString()}/` : "") + getFiltersAsString(),
    )
    url.searchParams.set("filterPath", filterPath)
    const search = getSearchText()
    if (search) {
        url.searchParams.set("suchTextOhneOrte", search)
    }
    return fetch(url.href)
        .then((res) => res.json())
        .then((res) => {
            setShowResultsButton(res.count)
            setCityAddresses(res.addresses)
        })
}
